import { render, staticRenderFns } from "./AppraisalApprovalCard.vue?vue&type=template&id=10027f72&scoped=true"
import script from "./AppraisalApprovalCard.vue?vue&type=script&lang=js"
export * from "./AppraisalApprovalCard.vue?vue&type=script&lang=js"
import style0 from "./AppraisalApprovalCard.vue?vue&type=style&index=0&id=10027f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10027f72",
  null
  
)

export default component.exports